import { render, staticRenderFns } from "./sb-staking-banner.vue?vue&type=template&id=58f6d7e7&scoped=true&"
import script from "./sb-staking-banner.vue?vue&type=script&lang=ts&"
export * from "./sb-staking-banner.vue?vue&type=script&lang=ts&"
import style0 from "./sb-staking-banner.vue?vue&type=style&index=0&id=58f6d7e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f6d7e7",
  null
  
)

export default component.exports